export const giftCardData = [
  {
    purchasedData: "Purchased: 05/15/2025",
    image: <img src="/images/amazon.png" alt="Amazon" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online",
    company: "Amazon",
    price: "$500",
    bg: "#C67300",
    expired: false,
  },
  {
    purchasedData: "Ppocessing",
    image: <img src="/images/nike.png" alt="Nike" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Nike",
    price: "$300",
    bg: "#191919",
    expired: false,
  },
  {
    expired: true,
    code: "FREE8CD89BAB45",
    pin: "8458",
  },
  {
    purchasedData: "Purchased: 05/15/2025",
    image: <img src="/images/amazon.png" alt="Amazon" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online",
    company: "Amazon",
    price: "$500",
    bg: "#C67300",
    expired: false,
  },
  {
    purchasedData: "Ppocessing",
    image: <img src="/images/nike.png" alt="Nike" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Nike",
    price: "$300",
    bg: "#191919",
    expired: false,
  },
];
// background: linear-gradient(0deg, #C67300, #C67300),
// linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%),
// linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));

export const giftCardStore = [
  {
    purchasedData: "10% Boost",
    image: <img src="/images/apple.png" alt="Apple" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Apple",
    price: "$100 - $2000",
    bg: "#3A3A3A",
  },
  {
    purchasedData: "10% Boost",
    image: <img src="/images/target.png" alt="target" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Target",
    price: "$100 - $2000",
    bg: "#E90000",
  },
  {
    purchasedData: "10% Boost",
    image: <img src="/images/bestBuy.png" alt="Best Buy" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Best Buy",
    price: "$100 - $2000",
    bg: "#0D00C6",
  },
  {
    purchasedData: "10% Boost",
    image: <img src="/images/nike.png" alt="Nike" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Nike",
    price: "$100 - $2000",
    bg: "#191919",
  },
  {
    purchasedData: "10% Boost",
    image: <img src="/images/apple.png" alt="Apple" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Apple",
    price: "$100 - $2000",
    bg: "#3A3A3A",
  },
  {
    purchasedData: "10% Boost",
    image: <img src="/images/target.png" alt="target" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Target",
    price: "$100 - $2000",
    bg: "#E90000",
  },
  {
    purchasedData: "10% Boost",
    image: <img src="/images/bestBuy.png" alt="Best Buy" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Best Buy",
    price: "$100 - $2000",
    bg: "#0D00C6",
  },
  {
    purchasedData: "10% Boost",
    image: <img src="/images/nike.png" alt="Nike" />,
    code: "FREE8CD89BAB45",
    pin: "8458",
    text: "Online & In-Store",
    company: "Nike",
    price: "$100 - $2000",
    bg: "#191919",
  },
];

export const companyConfig = {
  AMAZON: {
    logo: "/images/amazon.png",
    bg: "#C67300",
  },
  WALMART: {
    logo: "/images/walmart.png",
    bg: "#0071CE",
  },
  Apple: {
    logo: "/images/apple.png",
    bg: "#3A3A3A",
  },
  Target: {
    logo: "/images/target.png",
    bg: "#E90000",
  },
  BEST_BUY: {
    logo: "/images/bestBuy.png",
    bg: "#0D00C6",
  },
  NIKE: {
    logo: "/images/nike.png",
    bg: "#191919",
  },
  HOME_DEPOT: {
    logo: "/images/homeDepot.png",
    bg: "#ff6600",
  },
  KOHL: {
    logo: "/images/kohl.png",
    bg: "#860035",
  },
  LOWE: {
    logo: "/images/lowe.png",
    bg: "#002069",
  },
  REI: {
    logo: "/images/rei.png",
    bg: "#1e513e",
  },
  GAMESTOP: {
    logo: "/images/gamestop.png",
    bg: "#17120f",
  },
  ADIDAS: {
    logo: "/images/adidas.png",
    bg: "#18276e",
  },
  SOUTHWEST: {
    logo: "/images/southwest.png",
    bg: "#3850b2",
  },
  UBER: {
    logo: "/images/uber.png",
    bg: "#65252e",
  },
  DRAFTKINGS: {
    logo: "/images/draftKings.png",
    bg: "#67b717",
  },
  FANDUEL: {
    logo: "/images/fanduel.png",
    bg: "#0993fe",
  },
  // Add more companies as needed
};
